module.exports = __webpack_public_path__ + "media/cute-husky-puppy-yawning.ee205969.mp4";